import IframeService from '../abstract/IframeService';

export default class IframeServiceInjectObject {
  private name: string;

  private persistant: boolean;

  private service: IframeService;

  constructor(name: string, persistant: boolean, service: IframeService) {
    this.name = name;
    this.persistant = persistant;
    this.service = service;
  }

  getName(): string {
    return this.name;
  }

  isPersistant(): boolean {
    return this.persistant;
  }

  getService(): IframeService {
    return this.service;
  }
}
